module.exports = __webpack_public_path__ + "img/active_01.6a02e35d.jpg";